
import {spApi} from './sp'

export const spReviewPostApi = spApi.injectEndpoints({
  endpoints: (builder) => ({
    
    spReviewPost: builder.mutation({
      invalidatesTags: ['spreviews'],
      query: ({payload}) => ({
        url: '/createspreview',
        method: 'POST',
        body: payload,
      }),
    }),

  }),
  overrideExisting: false,
})

export const { useSpReviewPostMutation } = spReviewPostApi